import React from "react";

function ChannelHeadingChannelDropdown({ label }) {
  // @TODO this will become a dropdown eventually

  return <h2 className="heading heading--medium heading--icon">{label}</h2>;
}

export default ChannelHeadingChannelDropdown;
